<template>
  <data-table
    model="Platform\Models\Program"
  >
    <template v-slot:empty-head>
      <v-icon size="72" :color="$store.getters.app.color_name">record_voice_over</v-icon>
    </template>

    <template v-slot:empty-text>
      <p class="subheading">Locations where the brand is allocated.</p>
    </template>
  </data-table>
</template>
<script>
  export default {
    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>